<template>
    <dashboard-layout fullHeight>
        <template slot="tit">
            <v-row no-gutters align="center">
                <v-col cols="auto">
                    <h3 class="tit grey-c--text">채용관리</h3>
                </v-col>
                <v-col cols="auto">
                    <span class="tit__line" />
                </v-col>
                <v-col cols="auto">
                    <h3 class="tit">
                        {{ recruitment?.subject }}
                    </h3>
                </v-col>
            </v-row>
        </template>
        <template slot="contents">
            <v-row align-md="center" class="mb-n4 mb-md-12" style="flex: 0 0 auto;">
                <v-col cols="12" class="mb-10 mb-md-0">
                    <v-badge floating dot class="v-badge--btn">
                        <v-btn text @click="$router.go(-1)">
                            <i class="icon icon-left-arrow mr-4 mr-lg-8" />
                            <h4 class="tit--sm line-height-1">채용 리스트</h4>
                        </v-btn>
                    </v-badge>
                </v-col>
                <v-col cols="12" class="mb-12 mb-lg-0">
                    <v-row justify="end" align-lg="end" class="row--small">
                        <v-col class="d-none d-lg-block">
                            <p class="page-text grey--text">드래그하여 상태를 변경하세요.</p>
                        </v-col>
                        <v-col cols="6" sm="4" lg="auto">
                            <meeting-view :value="{ recruitment, applications }">
                                <template #activator="{ attrs, on }">
                                    <v-btn outlined small v-bind="attrs" v-on="on" color="grey-d" class="w-100 w-lg-160px">
                                        <span class="grey--text"> 전체항목 미팅요청 <v-icon size="18" class="ml-4">mdi-calendar</v-icon> </span>
                                    </v-btn>
                                </template>
                            </meeting-view>
                        </v-col>
                        <v-col cols="6" sm="4" lg="auto">
                            <texting-dialog :value="applications" :applications="applications" :paramsProps="{ _recruitment }" v-bind="{ recruitment }">
                                <template #activator="{ attrs, on }">
                                    <v-btn outlined small v-bind="attrs" v-on="on" color="grey-d" class="w-100 w-lg-160px">
                                        <span class="grey--text"> 전체항목 문자발송 <v-icon size="18" class="ml-4">mdi-email-outline</v-icon> </span>
                                    </v-btn>
                                </template>
                            </texting-dialog>
                        </v-col>
                        <v-col cols="12" sm="4" lg="auto">
                            <application-excel-btn :fileName="`${recruitment?.subject}_지원자_목록`" :selected="applications" small dark color="green darken-3" class="w-100 w-lg-160px">
                                <span> 엑셀파일 다운로드 <v-icon size="18" class="ml-4">mdi-tray-arrow-down</v-icon> </span>
                            </application-excel-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <p class="text-right page-text--sm grey--text mb-4 d-lg-none" style="flex: 0 0 auto;">상태값변경은 PC버전에서만 가능합니다.</p>

            <div class="kanban-item--groups">
                <v-row class="row-cols-lg-5 row--small h-lg-100">
                    <v-col v-for="{ value: key, text, color } in fields" :key="key" cols="12" md="6" lg="" class="h-lg-100">
                        <v-card flat rounded :dark="key == RECRUITMENT_KANBAN_FIELDS.REMOVED.value" :color="key == RECRUITMENT_KANBAN_FIELDS.REMOVED.value ? 'grey-5f' : 'grey-f1'" class="kanban-item--group fill-height" v-bind="{ loading }">
                            <div class="px-10 py-20 pb-lg-60 fill-height d-flex flex-column">
                                <div class="mb-12" style="flex: 0 0 auto">
                                    <v-row align="center" class="row--small">
                                        <v-col cols="auto">
                                            <v-layout align-center>
                                                <i :class="'mr-6 mr-lg-10 icon icon-dot icon-dot--' + color" />
                                                <p class="font-size-16 font-size-lg-18 font-weight-medium line-height-1">
                                                    {{ text }}
                                                </p>
                                            </v-layout>
                                        </v-col>
                                        <v-spacer />
                                        <v-col cols="auto">
                                            <v-menu left bottom nudge-bottom="36">
                                                <template #activator="{ attrs, on }">
                                                    <v-btn icon text small :color="key == RECRUITMENT_KANBAN_FIELDS.REMOVED.value ? 'white' : 'grey-13'" v-bind="attrs" v-on="on">
                                                        <v-icon>mdi-menu</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <meeting-view :value="{ recruitment, applications: stage[key] }">
                                                        <template #activator="{ attrs, on }">
                                                            <v-list-item outlined small v-bind="attrs" v-on="on">
                                                                <v-list-item-icon> <v-icon size="18">mdi-calendar</v-icon> </v-list-item-icon>
                                                                <v-list-item-title> 전체항목 미팅요청 </v-list-item-title>
                                                            </v-list-item>
                                                        </template>
                                                    </meeting-view>
                                                    <texting-dialog :value="stage[key]" :applications="applications" :paramsProps="{ _recruitment }" v-bind="{ recruitment }">
                                                        <template #activator="{ attrs, on }">
                                                            <v-list-item outlined small v-bind="attrs" v-on="on">
                                                                <v-list-item-icon> <v-icon size="18">mdi-email-outline</v-icon> </v-list-item-icon>
                                                                <v-list-item-title> 전체항목 문자발송 </v-list-item-title>
                                                            </v-list-item>
                                                        </template>
                                                    </texting-dialog>
                                                    <application-excel-btn tag="v-list-item" :fileName="`${recruitment?.subject}_${text}_목록`" :selected="stage[key]" dense>
                                                        <v-list-item-icon> <v-icon size="18">mdi-tray-arrow-down</v-icon> </v-list-item-icon>
                                                        <v-list-item-title> 엑셀파일 다운로드 </v-list-item-title>
                                                    </application-excel-btn>
                                                </v-list>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </div>
                                <draggable v-model="stage[key]" draggable=".kanban-item" group="application" @change="needsUpdate = true" class="kanban-items scroll-primary">
                                    <application-card v-for="item in stage[key]" :key="item?._id" :value="item" v-bind="{ recruitment }" flat rounded="lg" class="kanban-item" @input="search" />
                                </draggable>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </div>

        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import { RECRUITMENT_KANBAN_FIELDS } from "@/assets/variables";

import Draggable from "vuedraggable";
import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import ApplicationCard from "@/components/dashboard/company/application/application-card.vue";
import ApplicationExcelBtn from "@/components/dashboard/company/application/application-excel-btn.vue";
import TextingDialog from "@/components/dashboard/company/texting/texting-dialog.vue";
import MeetingView from "@/components/dashboard/company/meeting/view/meeting-view.vue";

const fields = Object.values(RECRUITMENT_KANBAN_FIELDS);

const initStage = () => fields.reduce((stage, { value }) => ({ ...stage, [value]: [] }), {});

export default {
    components: {
        Draggable,
        DashboardLayout,
        ApplicationCard,
        ApplicationExcelBtn,
        TextingDialog,
        MeetingView,
    },
    props: {
        _recruitment: { type: String },
    },
    data: () => ({
        fields,
        RECRUITMENT_KANBAN_FIELDS,

        loading: false,
        needsUpdate: false,

        kanban: undefined,
        recruitment: undefined,
        applications: [],

        stage: initStage(),
    }),
    mounted() {
        this.init();
    },
    watch: {
        needsUpdate() {
            this.update();
        },
    },
    methods: {
        init() {
            this.loading = false;
            this.kanban = undefined;
            this.recruitment = undefined;
            this.applications = [];
            this.stage = initStage();
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                var { kanban, recruitment, applications } = await api.v1.company.recruitments.kanban.get({ _recruitment: this._recruitment });
                this.kanban = kanban;
                this.recruitment = recruitment;
                this.applications = applications;

                for (const { value: key } of fields) {
                    this.stage[key] = (kanban?._applications?.[key] || []).map((_id) => applications.find((item) => item?._id == _id));
                }
            } finally {
                this.loading = false;
            }
        },
        async update() {
            this.needsUpdate = false;
            if (this.loading) return;

            this.loading = true;
            try {
                await api.v1.company.recruitments.kanban.put({
                    _recruitment: this._recruitment,
                    _applications: fields.reduce((_applications, { value: key }) => ({ ..._applications, [key]: this.stage[key].map(({ _id }) => _id) }), {}),
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.kanban-items {
    overflow-y: scroll;
    max-height: 60vh;
    padding-right: 10px;
}
.kanban-item:not(:last-child) {
    margin-bottom: 4px;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .kanban-item--groups {
        > .row > [class*="col"]:last-child {
            width: 100%;
            flex: 0 0 100%;
            max-width: 100%;
        }
    }
}
@media (min-width: 1024px) {
    .kanban-item--groups {
        overflow: hidden;
        width: 100%;
        height: calc(100vh - 412px);
        padding-bottom: 0;
        > .row > [class*="col"]:last-child {
            width: 20%;
            flex: 0 0 20%;
            max-width: 20%;
        }
    }
    .kanban-items {
        flex: 0 1 auto;
        height: 100%;
    }
}
@media (min-width: 1200px) {
}
@media (max-width: 1023px) {
    .kanban-item {
        pointer-events: none;
    }
}
</style>
